/*jshint browser: true */
/*global require: false, google: false */

require(['jquery', 'core'], function () {
    'use strict';

    var cx = '012879543055445490058:e7hodb6ayjc', // Replace with your CSE ID
        id = 'site-search'; // Div where search results will appear

    // Load Google CSE script
    function insertGoogleJavaScript() {
        var gcse = document.createElement('script');
        gcse.type = 'text/javascript';
        gcse.async = true;
        gcse.src = (document.location.protocol === 'https:' ? 'https:' : 'http:') +
            '//www.google.com/cse/cse.js?cx=' + cx;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gcse, s);
    }

    // Optional: remove default Google styles
    function removeGoogleStyles() {
        for (var i = 0; i < document.styleSheets.length; i++) {
            try {
                var sheet = document.styleSheets[i];
                if (sheet.href && sheet.href.indexOf('google.com') > 0) {
                    sheet.disabled = true;
                }
            } catch (e) { }
        }
    }

    // Remove "bad" query results containing ?query=
    function removeBadQueryResults() {
        var results = document.querySelectorAll('.gsc-webResult.gsc-result, .gsc-result');
        for (var i = 0; i < results.length; i++) {
            var link = results[i].querySelector('.gs-title a');
            var visibleEl = results[i].querySelector('.gs-visibleUrl-long, .gs-visibleUrl');
            var href = link ? link.href : '';
            var visibleText = visibleEl ? visibleEl.textContent : '';

            if ((href && href.indexOf('?query=') > -1) ||
                (visibleText && /(\?query\.\.\.[^\s]+)/i.test(visibleText))) {
                if (results[i].parentNode) {
                    results[i].parentNode.removeChild(results[i]);
                    i--;
                }
            }
        }
    }

    // Check for zero results and show message
    function checkEmptyResults() {
        var container = document.querySelector('.gsc-results-wrapper-visible');
        var pager = document.querySelector('.gsc-cursor-box');
        var noResultsMsg = document.getElementById('no-results-message');

        // Detect zero results even if .gs-title doesn't exist
        var hasNoResults = container && (container.querySelector('.gsc-no-results') ||
            container.querySelectorAll('.gsc-webResult.gsc-result, .gsc-result').length === 0);

        if (hasNoResults) {
            if (container) container.style.display = 'none';
            if (pager) pager.style.display = 'none';

            if (!noResultsMsg && container && container.parentNode) {
                noResultsMsg = document.createElement('div');
                noResultsMsg.id = 'no-results-message';
                noResultsMsg.className = 'gsc-webResult gsc-result'; // Styled like a real result
                noResultsMsg.innerHTML =
                    '<div class="gs-title">' +
                    '<a href="javascript:void(0);" style="color:#1a0dab; text-decoration:none; cursor:default;">No results found</a>' +
                    '</div>' +
                    '<div class="gs-visibleUrl" style="color:#006621; font-size:small;">&nbsp;</div>' +
                    '<div class="gs-snippet">Your search did not match any documents.</div>';
                container.parentNode.insertBefore(noResultsMsg, container);
            }
        } else {
            if (container) container.style.display = '';
            if (pager) pager.style.display = '';
            if (noResultsMsg && noResultsMsg.parentNode) noResultsMsg.parentNode.removeChild(noResultsMsg);
        }
    }

    // Cleanup results
    function cleanResultsTick() {
        removeBadQueryResults();
        checkEmptyResults();
    }

    // Monitor Google CSE DOM changes
    function monitorGSC() {
        var timer;
        var observer = new MutationObserver(function () {
            clearTimeout(timer);
            timer = setTimeout(cleanResultsTick, 100);
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // Called after Google CSE is loaded
    function googleLoadedCallback() {
        removeGoogleStyles();
        try {
            google.search.cse.element.render({ div: id, tag: 'search', gname: id });
        } catch (e) { }
        monitorGSC();
        setTimeout(cleanResultsTick, 500);
    }

    // Explicit CSE callback
    window.__gcse = {
        parsetags: 'explicit',
        callback: function () {
            if (document.readyState === 'complete') {
                googleLoadedCallback();
            } else {
                google.setOnLoadCallback(googleLoadedCallback, true);
            }
        }
    };

    insertGoogleJavaScript();
});
define("site-search", function(){});

